import { Box, useBreakpointValue } from "native-base";
import React from "react";

import MobileHeader from "@/components/molecules/MobileHeader";
import SimpleWebHeader from "@/components/molecules/SimpleWebHeader";
import Container from "@/components/organisms/Container";

import OrderEvaluationContainer from "./components/OrderEvaluationContainer";
import { OrdeEvaluationScreenProps } from "./types";

const OrderEvaluationWeb = ({ isLoading, onGoBack, ...props }: OrdeEvaluationScreenProps) => {
  const paddingX = useBreakpointValue({
    base: "1/5",
    xl: "1/4",
    "2xl": "1/3",
  });
  return (
    <Container px={paddingX} Header={<SimpleWebHeader />}>
      <Box py="4">
        <MobileHeader title="Avaliação" showLogo={false} onBackPress={onGoBack} />
      </Box>
      {isLoading ? <Box /> : <OrderEvaluationContainer {...props} />}
    </Container>
  );
};

export default OrderEvaluationWeb;
